<script setup>
import { computed, ref } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import TranslationLine from 'custom/dashboard/extensions/translation/components/TranslationLine.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_TYPES } from '../constants';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const { attachments, id, conversationId, messageType, contentAttributes } =
  useMessageContext();
const store = useStore();
const { t } = useI18n();

const busy = ref(false);

const attachment = computed(() => attachments.value?.[0]);

const transcribedText = computed(
  () => (attachment.value?.transcribedText || '').trim()
);

const sttStatus = computed(() => attachment.value?.sttStatus || '');

const showTranscribeButton = computed(() => {
  if (messageType.value !== MESSAGE_TYPES.INCOMING) return false;
  if (transcribedText.value) return false;
  if (sttStatus.value === 'pending') return false;
  return !!attachment.value?.id;
});

const isPending = computed(() => sttStatus.value === 'pending' || busy.value);

const accountId = computed(() => store.getters.getCurrentAccountId);

const requestTranscribe = async () => {
  if (!attachment.value?.id || busy.value) return;
  busy.value = true;
  try {
    await window.axios.post(
      `/api/v1/accounts/${accountId.value}/attachments/${attachment.value.id}/voice_transcribe`
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[voice_transcribe] manual failed', err?.response?.data || err);
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <!-- FORK_PATCH_BEGIN: voice-transcription — transcript translation + manual STT -->
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <div class="flex flex-col gap-2">
      <AudioChip
        :attachment="attachment"
        class="p-2 text-n-slate-12 skip-context-menu"
      />
      <div v-if="isPending" class="text-xs text-n-slate-11 px-1">
        {{ t('CUSTOM.VOICE_TRANSCRIBE.PENDING') }}
      </div>
      <button
        v-else-if="showTranscribeButton"
        type="button"
        class="self-start text-xs px-2 py-1 rounded-md border border-n-weak text-n-slate-12 hover:bg-n-alpha-2"
        @click="requestTranscribe"
      >
        {{ t('CUSTOM.VOICE_TRANSCRIBE.BUTTON') }}
      </button>
      <TranslationLine
        v-if="messageType === MESSAGE_TYPES.INCOMING && transcribedText"
        :message-id="id"
        :conversation-id="conversationId"
        :content="transcribedText"
        :content-attributes="contentAttributes"
      />
    </div>
  </BaseBubble>
  <!-- FORK_PATCH_END: voice-transcription -->
</template>
